import { COVERGO_SAAS_PROD, COVERGO_SAAS_DEV } from "../consts.js"

export const xn = {
	// CoverGo PROD
	"xn-uat-studio.quote.hk": { appConfig: { tenantId: "xn_uat", appId: "covergo_crm" }, envConfig: COVERGO_SAAS_PROD },

	// XN AWS DEV
	"studio.covergo-dev.xn.com": {
		appConfig: { tenantId: "xn_dev", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.covergo-dev.xn.com/graphql",
			COVERGO_FILE_SYSTEM: "https://api.covergo-dev.xn.com/api/v1/files"
		}
	},
	
	// XN AWS UAT
	"studio.covergo-uat.xn.com": {
		appConfig: { tenantId: "xn_uat", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.covergo-uat.xn.com/graphql",
			COVERGO_FILE_SYSTEM: "https://api.covergo-uat.xn.com/api/v1/files"
		}
	},

	// XN AWS PROD
	"studio.covergo.xn.com": {
		appConfig: { tenantId: "xn", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.covergo.xn.com/graphql",
			COVERGO_FILE_SYSTEM: "https://api.covergo.xn.com/api/v1/files"
		}
	}
}

export const xn_dev = {
	"xn-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "xn_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
